import React, { useEffect } from 'react';
import {
  useSpotifyControllerAuthenticateMutation,
  useSpotifyControllerConnectMutation,
} from '@/store/services/MidleNestApi.service';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useProfile } from '@/hooks';
import { useAuthenticated } from '@/hooks/useAuthenticated.hook';
import { ErrorBoundary, LoadingLayout } from '@/components';
import { storageLocal } from '@/utils';
import { connection } from '@/utils/connection.utils';
import { useTranslation } from 'react-i18next';

export function Component() {
  const { isAuthenticated } = useAuthenticated();
  const [authenticate] = useSpotifyControllerAuthenticateMutation();
  const [connect] = useSpotifyControllerConnectMutation();
  const navigate = useNavigate();
  const { reloadProfile } = useProfile();
  const platform = storageLocal.getItem('platform') || '';

  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const [error, setError] = React.useState('');

  const code = searchParams.get('code') || '';

  useEffect(() => {
    (async () => {
      try {
        if (isAuthenticated) {
          await connect({
            code: code,
          }).unwrap();

          gtag('event', 'connect-spotify', { platform });
          reloadProfile().then(() => {
            connection.redirect(navigate, '/tasks');
          });
        } else {
          await authenticate({
            code: code,
            ref: storageLocal.getItem('ref') || undefined,
          }).unwrap();

          gtag('event', 'auth-spotify', { platform });
          connection.redirect(navigate, '/');
        }
      } catch (err: any) {
        const data = err?.data;

        if (data?.message && data?.message.includes('duplicate')) {
          setError(
            t(
              'This account is already linked to another Midle account. Please disconnect it first to use it with this account.',
            ),
          );
        } else {
          setError(t('An error occurred. Please try again later.'));
        }
      }

      localStorage.removeItem('connect_provider');
    })();
  }, []);

  return (
    <>
      {error ? (
        <div className='bg-[#242424] rounded-lg max-w-[95%] text-white w-max px-4 py-3 mx-auto mt-12'>
          {error}
        </div>
      ) : (
        <LoadingLayout />
      )}
    </>
  );
}

Component.displayName = 'SpotifyConnectionSuccess';
export { ErrorBoundary };
